(() => {
  const buyNowSelector = '[data-oaklen-buy-now]';
  const quantitySelector = '.oaklen-collection-card__quantity-input';

  const updateBuyNowUrl = (buyNowLink) => {
    const form = buyNowLink.closest('form');
    const quantityInput = form?.querySelector(quantitySelector);
    const variantInput = form?.querySelector('input[name="id"]');
    const quantity = Math.max(parseInt(quantityInput?.value, 10) || 1, 1);
    const variantId = variantInput?.value || buyNowLink.dataset.variantId;
    const cartUrl = buyNowLink.dataset.cartUrl;

    if (!variantId || !cartUrl) return;

    buyNowLink.href = `${cartUrl}/${variantId}:${quantity}`;
  };

  const updateClosestBuyNowUrl = (target) => {
    const form = target.closest('form');
    const buyNowLink = form?.querySelector(buyNowSelector);

    if (buyNowLink) updateBuyNowUrl(buyNowLink);
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches(quantitySelector))
      updateClosestBuyNowUrl(event.target);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches(quantitySelector))
      updateClosestBuyNowUrl(event.target);
  });

  document.addEventListener('click', (event) => {
    const buyNowLink = event.target.closest(buyNowSelector);

    if (buyNowLink) updateBuyNowUrl(buyNowLink);
  });
})();
